import { Injectable } from '@angular/core';
import { URLS } from '../constants/URLS';
import { HttpClient, HttpHeaders } from '@angular/common/http';
import { Observable } from 'rxjs';
@Injectable({
  providedIn: 'root'
})
export class DeleteService {
  constructor(private http: HttpClient) { }

   deleteProfile(): Observable<any> {
    // const httpOptions = {
    //   headers: new HttpHeaders({
    //     'Authorization': 'Bearer ' + jwtToken
    //   })
    // };

    return this.http.post<any>(URLS.getDeleteProfile, {});
    

  }

  addToWatchlist(videoData: any[]): void {
    let watchlist = this.getWatchlist();
    if (!watchlist.includes(videoData)) {
      watchlist.push(videoData);
      localStorage.setItem('watchlist', JSON.stringify(watchlist));
    }
  }

  addToWatchHistory(videoData: any[]): void {
    let watchlist = this.getWatchHistory();
    if (!watchlist.includes(videoData)) {
      watchlist.push(videoData);
      localStorage.setItem('watchHistory', JSON.stringify(watchlist));
    }
  }

  removeFromWatchlist(vidLibId: number): void {
    console.log(vidLibId);
    let watchlist = this.getWatchlist();
    const index = watchlist.findIndex(video => video.vidLibId === vidLibId);
    console.log(index);
    if (index !== -1) {
      watchlist.splice(index, 1);
      localStorage.setItem('watchlist', JSON.stringify(watchlist));
    }
  }

  getWatchlist(): any[] {
    const watchlistString = localStorage.getItem('watchlist')? localStorage.getItem('watchlist'):'';
    return watchlistString ? JSON.parse(watchlistString) : [];
  }

  getWatchHistory(): any[] {
    const watchlistString = localStorage.getItem('watchHistory')? localStorage.getItem('watchHistory'):'';
    return watchlistString ? JSON.parse(watchlistString) : [];
  }

  isInWatchlist(vidLibId: number): boolean {
    const watchlist = this.getWatchlist();
    return watchlist.some(video => video.vidLibId === vidLibId);
  }
}
